/* Coyote Stickers safety checks (Oct 2026). Loaded on every page from layout/theme.liquid.
   1. Checkout guard: a custom seals line with no artwork (and no reorder number) can't be printed, so any
      checkout button outside the cart page sends the customer to the cart, where the artwork notice explains it.
   2. Builder uploads: only PNG, JPG, SVG, PDF and AI files up to 25 MB are accepted (the upload service limit).
   3. Builder QR code: only web links (http or https). A bare address like instagram.com/shop gets https:// added. */
(function () {
  'use strict';
  var HANDLE = 'customseals';

  /* 1. Checkout guard */
  function badSeals(cart) {
    return (cart && cart.items || []).some(function (i) {
      var p = i.properties || {};
      return i.handle === HANDLE && !p.Artwork && !p['Order type'];
    });
  }
  function isCheckout(el) {
    if (!el || !el.closest) return null;
    var b = el.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"], a[href*="/checkout?"], a[href$="/checkout"]');
    return b;
  }
  var passing = false;
  document.addEventListener('click', function (e) {
    if (passing || /^\/cart\/?$/.test(location.pathname)) return;
    var b = isCheckout(e.target);
    if (!b) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { location.href = badSeals(c) ? '/cart' : '/checkout'; })
      .catch(function () { location.href = '/checkout'; });
  }, true);

  /* 2 and 3 only apply on the builder page */
  function onBuilder() { return !!document.getElementById('msb-root'); }

  /* 2. Upload limits */
  var MAX = 25 * 1024 * 1024;
  var OK_EXT = /\.(png|jpe?g|svg|pdf|ai)$/i;
  var OK_FULL = /\.(png|jpe?g)$/i; /* full seal artwork: PNG or JPG only */
  function problem(file, fullSeal) {
    if (!file) return '';
    if (file.size > MAX) return file.name + ' is over 25 MB. Please upload a smaller file.';
    if (!(fullSeal ? OK_FULL : OK_EXT).test(file.name || '')) {
      return fullSeal ? 'Full seal artwork must be a PNG or JPG file.' : 'Please upload a PNG, JPG, SVG, PDF or AI file.';
    }
    return '';
  }
  function say(msg) {
    var n = document.getElementById('msb-uploadErr');
    if (!n) {
      n = document.createElement('p');
      n.id = 'msb-uploadErr';
      n.className = 'note err';
      n.setAttribute('role', 'alert');
      var anchor = document.getElementById('msb-dropLogo');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(n, anchor);
    }
    n.hidden = !msg;
    n.textContent = msg || '';
    if (msg && n.scrollIntoView) n.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!onBuilder() || !t || t.type !== 'file' || !t.closest('#msb-root')) return;
    var f = t.files && t.files[0], msg = problem(f, t.id === 'msb-fileCustom');
    if (msg) { e.stopImmediatePropagation(); t.value = ''; say(msg); } else say('');
  }, true);
  document.addEventListener('drop', function (e) {
    var d = e.target && e.target.closest && e.target.closest('#msb-root .drop');
    if (!onBuilder() || !d) return;
    var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0], msg = problem(f, d.id === 'msb-dropCustom');
    if (msg) { e.preventDefault(); e.stopImmediatePropagation(); d.classList.remove('over'); say(msg); } else say('');
  }, true);

  /* 3. QR link: web links only */
  function qrState() {
    var q = document.getElementById('msb-qrLink'), mode = document.getElementById('msb-backQr');
    if (!q || !mode || mode.getAttribute('aria-pressed') !== 'true') return { ok: true };
    var v = q.value.trim();
    if (!v) return { ok: true }; /* the builder already asks for a link when it's empty */
    if (/^https?:\/\/[^\s]+\.[^\s]+/i.test(v)) return { ok: true };
    return { ok: false, q: q };
  }
  function qrNote(msg) {
    var q = document.getElementById('msb-qrLink'); if (!q) return;
    var n = document.getElementById('msb-qrErr');
    if (!n) { n = document.createElement('p'); n.id = 'msb-qrErr'; n.className = 'note err'; n.setAttribute('role', 'alert'); q.parentNode.insertBefore(n, q.nextSibling); }
    n.hidden = !msg; n.textContent = msg || '';
  }
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'msb-qrLink') return;
    var q = e.target, v = q.value.trim();
    if (v && !/^[a-z][a-z0-9+.-]*:/i.test(v) && /^[^\s\/]+\.[^\s]+$/.test(v)) {
      q.value = 'https://' + v.replace(/^\/+/, '');
      q.dispatchEvent(new Event('input', { bubbles: true }));
    }
    qrNote(qrState().ok ? '' : 'The QR code needs a web link, like https://instagram.com/yourshop.');
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('#msb-addCart');
    if (!b || !onBuilder()) return;
    var s = qrState();
    if (!s.ok) {
      e.preventDefault(); e.stopImmediatePropagation();
      qrNote('The QR code needs a web link, like https://instagram.com/yourshop.');
      s.q.scrollIntoView({ block: 'center', behavior: 'smooth' }); s.q.focus({ preventScroll: true });
    }
  }, true);
})();
